import React from "react"
import CustomTag from "components/Atoms/CustomTag"
import { keysIn, startCase, isArray, isBoolean, isObject } from "lodash-es"
import { useSelector, useDispatch } from "react-redux"
import { DEMAND_REMOVE_FILTER_PARAMETER } from "store/demand.redux"
import clsx from "utils/clsx"
const getDisplayValue = (filterValue: any) => {
  if (isArray(filterValue)) {
    return filterValue.join(" , ")
  } else if (isObject(filterValue as any)) {
    return filterValue.name
  } else if (isBoolean(filterValue)) {
    return filterValue ? "yes" : "no"
  } else {
    return filterValue
  }
}
const SearchFilterTags = () => {
  const filter = useSelector((state: any) => state.demands.filter)
  const allFilters = keysIn(filter)
  const dispatch = useDispatch()
  return (
    <div className="flex justify-start items-baseline">
      {allFilters.map((fk, idx) => {
        // Get the filter value for the given key
        const filterValue = filter[fk]
        const displayName = startCase(fk)

        return (
          <span key={idx}>
            {filterValue ? (
              <CustomTag
                className={clsx("mr-2")}
                onRemove={e => {
                  dispatch({
                    type: DEMAND_REMOVE_FILTER_PARAMETER,
                    payload: [fk],
                  })
                }}
              >
                {displayName} - {getDisplayValue(filterValue)}
              </CustomTag>
            ) : null}
          </span>
        )
      })}
    </div>
  )
}

export default SearchFilterTags
